import { Stack, Typography, Box, IconButton, Link } from '@mui/material';
import { LinkedIn, GitHub } from '@mui/icons-material';

function Footer() {
    // Design system constants
    const PRIMARY_COLOR = '#6C98AD';
    const TRANSITION = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';

    // Social media links configuration
    const socialMediaLinks = [
        {
            id: 1,
            name: 'LinkedIn',
            icon: LinkedIn,
            url: 'https://www.linkedin.com/company/tailoredalloys',
            ariaLabel: 'Visit our LinkedIn page'
        },
        {
            id: 2,
            name: 'GitHub',
            icon: GitHub,
            url: 'https://github.com/Tailored-Alloys',
            ariaLabel: 'Visit our GitHub profile'
        },
        // {
        //     id: 3,
        //     name: 'Twitter',
        //     icon: Twitter,
        //     url: 'https://twitter.com',
        //     ariaLabel: 'Visit our Twitter profile'
        // },
        // {
        //     id: 4,
        //     name: 'Facebook',
        //     icon: Facebook,
        //     url: 'https://facebook.com',
        //     ariaLabel: 'Visit our Facebook page'
        // }
    ];

    return (
        <Stack className='App-footer' spacing={3}>
            <Box sx={{ textAlign: 'center', width: '100%', px: 2, pt: 1 }}>
                <img
                    src={process.env.PUBLIC_URL + '/tailoredalloyslogo.png'}
                    alt="TailoredAlloysLogo"
                    style={{ marginBottom: '16px', filter: 'brightness(0) invert(1)', maxWidth: '70%', height: 'auto', maxHeight: '45px' }}
                />

                <Typography
                    variant="body1"
                    sx={{
                        opacity: 0.85,
                        maxWidth: '600px',
                        margin: '0 auto',
                        color: 'rgba(255, 255, 255, 0.85)',
                        lineHeight: 1.6
                    }}
                >
                    Process Mastery Through Build Transparency, and reproducible digital threads: optimizing LPBF additive manufacturing for first-time-right qualification.
                </Typography>
            </Box>

            <Stack direction="row" spacing={2} justifyContent="center">
                {socialMediaLinks.map((social) => {
                    const IconComponent = social.icon;
                    return (
                        <IconButton
                            key={social.id}
                            aria-label={social.ariaLabel}
                            href={social.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'rgba(255, 255, 255, 0.85)',
                                transition: TRANSITION,
                                '&:hover': {
                                    color: PRIMARY_COLOR,
                                    transform: 'translateY(-4px)',
                                    backgroundColor: 'rgba(108, 152, 173, 0.1)',
                                }
                            }}
                        >
                            <IconComponent fontSize="large" />
                        </IconButton>
                    );
                })}
            </Stack>

            <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 2, md: 4 }}
                justifyContent="center"
                alignItems="center"
                sx={{
                    fontSize: '0.95rem'
                }}
            >
                <Link
                    href="/about"
                    underline="hover"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.75)',
                        transition: TRANSITION,
                        '&:hover': {
                            color: PRIMARY_COLOR,
                        }
                    }}
                >
                    About
                </Link>
                <Link
                    href="/#contact"
                    underline="hover"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.75)',
                        transition: TRANSITION,
                        '&:hover': {
                            color: PRIMARY_COLOR,
                        }
                    }}
                >
                    Contact Us
                </Link>
            </Stack>

            <Typography
                variant="body2"
                sx={{
                    opacity: 0.6,
                    fontSize: '0.875rem',
                    color: 'rgba(255, 255, 255, 0.6)',
                    textAlign: 'center'
                }}
            >
                © {new Date().getFullYear()} Tailored Alloys. All rights reserved.
            </Typography>
        </Stack>
    );
}

export default Footer;